import React from "react";
import classNames from "classnames";

import ShowPasswordIcon from "../../../Icon/ShowPassword";
import HidePasswordIcon from "../../../Icon/HidePassword";
import InputGroup from "../../InputGroup";
import { TextInput } from "../Input";
import { InputPropTypes } from "../../../propTypes";

import "./styles.scss";

const Password = props => {
  const [inputType, setInputType] = React.useState("password");
  const iconType = React.useMemo(
    () =>
      inputType === "password" ? <ShowPasswordIcon /> : <HidePasswordIcon />,
    [inputType]
  );

  const onToggleVisibility = React.useCallback(() => {
    setInputType(inputType === "password" ? "text" : "password");
  }, [inputType, setInputType]);

  const append = React.useMemo(() => {
    return (
      <div
        onClick={onToggleVisibility}
        className={classNames(
          "icon",
          props.error && "icon-error",
          props.disabled && "icon-disabled",
          props.readonly && "icon-readonly"
        )}
      >
        {iconType}
      </div>
    );
  }, [iconType, onToggleVisibility, props]);

  return (
    <InputGroup
      className={classNames(
        "mydpd-password-control",
        props.rounded && "rounded"
      )}
      append={append}
    >
      <TextInput {...props} type={inputType} />
    </InputGroup>
  );
};

Password.propTypes = InputPropTypes;

export default Password;
